<div class="settle-line d-flex justify-content-between flex-row" [ngClass]="{ bold: bold }">
  <div class="settle-line-title">
    {{ title }}
  </div>
  <div class="settle-line-count">
    {{ count }}
  </div>
</div>
